(ns teamoesterreich.admin-mode.crowdtasker.task.crowdtasker-task-detail
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.eventTask :as d-eventTask]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.crowdtasker.task.task-detail-form :as task-detail-form]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [goog.json :as json]
            [clojure.string :as str]
            [teamoesterreich.admin-mode.crowdtasker.task.task-region :as task-region]
            [teamoesterreich.admin-mode.crowdtasker.task.task-question-list :as question-list]

            [teamoesterreich.admin-mode.crowdtasker.event-user-table :as event-user-table]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [reagent-material-ui.icons.send :refer [send]]
            ))


(defn date-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20
  (if (> (count dateTime) 12)
    (str  (subs dateTime 6 8) "." (subs dateTime 4 6)  "."(subs dateTime 0 4))
    ""
    ))

(defn get-it []
  (let [!st (r/atom {})]
    (fn []
      (let [!event (r/cursor vstate/app-state [:selected-event])

            !event-task (r/cursor vstate/app-state [:selected-task])
            !actual-user (r/cursor store/app-state [:actual-user])
            !tab (r/cursor vstate/app-state [:crowdtasker-task-tab])
            !event-task-details-loaded? (r/cursor vstate/app-state [:event-task-loaded])
            reload-fn #(reset! !event-task-details-loaded? false)

            !publish-popup (r/cursor !st [:publish-popup])
            event-status (or (:crowdtaskerEvent-status @!event) "created")
            task-published (:crowdtaskerTask-published @!event-task)
            event-step (case event-status
                         "created" 0
                         "waitAccept" 1
                         "running" 2
                         "finished" 3
                         "closed" 4
                         0)
            from-date (:crowdtaskerTask-timeFrom @!event-task)
            to-date (:crowdtaskerTask-timeTo @!event-task)
            name (:crowdtaskerTask-name @!event-task)
            description (:crowdtaskerTask-description @!event-task)
            ]
        (log/debug "event-task " @!event-task)
        [mui/grid
         {:container false :item true
          :md 12  ;medium: 960px
          :xs 12  ;extra-small: 0px
          :style {:marginTop "5px"}
          }


         [mui/button {:startIcon (r/as-element [keyboard-arrow-left]) :variant "outlined" :style {:margin "5px 40px 5px 0"}
                      :onClick #(swap! vstate/app-state assoc :site :event-list)
                      }
          "Zurück"]

         [mui/button {:startIcon (r/as-element [refresh])
                      :onClick #(reset! !event-task-details-loaded? false)}
          "Neu laden ...."
          ]]

        (if-not @!event-task-details-loaded?
          (do
            (d-eventTask/<task-load (:crowdtaskerTask-uuid @!event-task)
                                    (fn [response]
                                      (reset! !event-task response)
                                      (reset! !event-task-details-loaded? true)
                                      ))
            [mui/grid
             {:container false :item true
              :md 12  ;medium: 960px
              :xs 12  ;extra-small: 0px
              :style {:marginTop "5px"}
              }
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
             [mui/typography {} "Lade Daten ... "]
             ]
            )

          [mui/grid
           {:container false :item true
            :md 12  ;medium: 960px
            :xs 12  ;extra-small: 0px
            :style {:marginTop "5px"}
            }
           [mui/card
            [are-you-sure-modal/are-you-sure-modal !publish-popup
             "Bist du sicher, dass du diese Aufgabe veröffentlichen möchtest? Alle Teilnehmer werden sie sehen können!" "Ja veröffentlichen"
             (fn [_] (d-eventTask/>task-save (:crowdtaskerTask-uuid @!event-task) {:crowdtaskerTask-published true}  reload-fn)) ]
            [mui/card-content {:style {:textAlign "left"} }
             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "flex-start"
               :alignItems "flex-start"
               :spacing    3
               :style      {:margin "0"}
               }

              [mui/grid
               {:container false :item true
                :md 9
                :xs 12
                :style     {:padding "5px"}
                }
               [:h2
                [mui/button {:variant   "contained"
                             :style {:marginRight "30px"}
                             :onClick #(swap! vstate/app-state assoc
                                              :selected-task nil
                                              :site :crowdtasker-event-overview
                                              )
                             :startIcon (r/as-element [keyboard-arrow-left])}
                 "Zurück"]
                [:span {:style {:color "#0054ff"}} (str " `" (:crowdtaskerEvent-name @!event) "` (" (date-conv (:crowdtaskerEvent-timeFrom @!event)) ")") ]
                (str " -> Aufgabe `" (:crowdtaskerTask-name @!event-task) "`")]]

              [mui/grid
               {:container false :item true
                :md 3
                :xs 12
                :style     {:padding "5px"}
                }
               (when (> event-step 1)
                 (if (and name from-date to-date description)
                   [mui/form-group
                    [mui/form-control-label
                     {:style {:paddingLeft "126px"}
                      :label "Aufgabe veröffentlichen"
                      :fullWidth true
                      :control (r/as-element
                                 [mui/switch {:checked (or (:crowdtaskerTask-published @!event-task) false)
                                              :onChange (fn [_ v]
                                                          (if v (reset! !publish-popup true)
                                                                (d-eventTask/>task-save (:crowdtaskerTask-uuid @!event-task) {:crowdtaskerTask-published false}  reload-fn)))
                                              }])}
                     ]]
                   [:span {:style {:color "red" }} (if (not (and name from-date to-date description)) "Name, Beschreibung, Begin und Ende müssen angegeben sein" "")]))
               ]]]

            [mui/card-content {}
             (log/debug "Open Tab " @!tab)
             [mui/tabs {:value  (or @!tab 0)
                        :onChange (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                        :indicatorColor "primary"
                        :textColor "primary"
                        :variant "scrollable"
                        }
              [mui/tab {:value 0 :label "Details"}]

              [mui/tab {:value 1 :label "Region"}]

              [mui/tab {:value 2 :label "Fragebogen"}]


              ; creating / isWaiting



              ]
             ;;show-absent? show-standby? show-participated?
             (case (or @!tab 0)
               0 [task-detail-form/get-it !event-task task-published]

               1 [mui/card-content {}
                  [(task-region/region-selector)]]

               2 [mui/card-content {}
                  [(question-list/get-it)]]


               99 [mui/card-content {}
                   [:p "Übersicht über Task....."]
                   [:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!event-task)) "," ",\n")]]

               )
             ]]
           ])))))


















